import API from "../../services/api";

export async function fetchCompOffSettings() {
  const { data } = await API.get("/comp-off/settings");
  return data;
}

export async function saveCompOffSettings(payload) {
  const { data } = await API.put("/comp-off/settings", payload);
  return data;
}

export async function fetchCompOffCalendar() {
  const { data } = await API.get("/comp-off/calendar");
  return data;
}

export async function fetchMyCompOff(employeeId) {
  const { data } = await API.get("/comp-off/me", {
    params: employeeId ? { employee_id: employeeId } : undefined,
  });
  return data;
}

export async function fetchCompOffManage(section, page = 1, pageSize = 20, employeeId) {
  const { data } = await API.get("/comp-off/manage", {
    params: {
      section,
      page,
      page_size: pageSize,
      ...(employeeId ? { employee_id: employeeId } : {}),
    },
  });
  return data;
}

export async function fetchCompOffCredits({ status, page = 1, pageSize = 50 } = {}) {
  const { data } = await API.get("/comp-off/credits", {
    params: { status, page, page_size: pageSize },
  });
  return data;
}

export async function decideCompOffCredit(creditId, decision, reason) {
  const { data } = await API.post(`/comp-off/credits/${creditId}/decision`, { decision, reason });
  return data;
}

export async function adjustCompOff(payload) {
  const { data } = await API.post("/comp-off/adjustments", payload);
  return data;
}

export async function processCompOffAttendance(payload) {
  const { data } = await API.post("/comp-off/process", payload);
  return data;
}

export async function fetchCompOffRoster() {
  const { data } = await API.get("/comp-off/roster");
  return data;
}

export async function requestCompOff(payload) {
  const { data } = await API.post("/comp-off/requests", payload);
  return data;
}
